<template>
    <div class="mw-fast-news bgWhite p15" style="max-height: 480px; height: auto;">
        <h3><img src="../assets/images/gctjxx.png" alt="" srcset=""></h3>
        <div>
            <div class="fast-news-list" v-for="(item, index) in msg_list" :key="index">
                <span class="fontWhite">{{ item.sdate.substr(11, 5) }}</span><br>
                <p class="fontLight">{{ item.info }}</p>
            </div>
        </div>

        <div class="fast-news-ad">
            <a :href="link ? link : ''" target="_blank" rel="">
                <img :src="ad ? ad : defaultAd" alt="" style="height: 80px;" class="w100">
            </a>
            <!-- <img src="../assets/images/ad_4.png" alt="" style="height: 80px;" class="w100"> -->
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { baseUrl } from '../assets/js/common'
export default {
    name: 'ModifyPriceControl',
    components: {  },
    props: {
        ad: String,
        link: String
    },
    data () {
        return {
            defaultAd: require('../assets/images/ad_1.png'),
            userInfo: {},
            msg_list: []
        }
    },
    mounted () {
        // 初始化内容
        this.getUserAllInfo();
    },
    methods: {
        getUserAllInfo () {
            const token_cyw = this.$cookies.get('token_cyw');
            if (token_cyw) {
                const self = this;
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        self.$get(`${baseUrl.business}/api/user/find/${res_1.data.id}`, {}).then(res => {
                            if(res.status == 200) {
                                if (res.data == null) {
                                    self.$message.error('未获取到身份信息')
                                } else {
                                    self.userInfo = res.data;
                                    self.getSignTreeList();
                                }
                            } else {
                                self.$message.error('获取信息失败')
                            }
                        })
                    } else {
                        self.$message.error(res_1.msg);
                    }
                }).catch(err_1 => {
                    self.$confirm('未获取到此用户信息', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'error'
                    }).then(() => {
                        self.$router.push('/index')
                    })
                })
                
            }
        },
        // 查询用户定制的报价
        getSignTreeList () {
            const self = this;
            self.$get(`${baseUrl.crm}/business/cyw/openapi/getSignTreeList.json/${self.userInfo.crmUserId}`, {}).then(res => {
                if (res.code == 200) {
                    if (res.data.length > 0) {
                        self.list_data = res.data;
                        self.priceType = res.data[0]['groupPid'];
                        self.getMsgInfo()
                    }
                } else {
                    self.$message.error(res.msg);
                }
            }).catch(error => {
                self.$message.error('查询分类信息失败')
            })
        },

        getMsgInfo () {
            const self = this;
            $.ajax({
                url: `${baseUrl.modify}/API_V1/API_MSGBYMSSQL/MSG_INFO?keyword=&sdate=&edate=&pz=${self.priceType}&pagenum=1&pernum=4`,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        // console.log(res.data)
                        self.msg_list = res.data;
                    } else {
                        self.$message.error(res.message);
                    }
                },
                error: () => {
                    self.$message.error('未获取到报价信息')
                }
            })
        }
    },
}
</script>

<style scoped>
    .mw-fast-news { height: 400px; }
    .mw-fast-news h3 { padding-bottom: 10px; }
    .mw-fast-news .ad { height: 90px; margin: 15px 0; }
    .mw-fast-news .fast-news-list { padding: 10px 0; border-bottom: 1px solid #ececec; }
    .mw-fast-news .fast-news-list:last-child { border: 0; }
    .mw-fast-news .fast-news-list span { padding: 1px 10px; background: #a30000; border-radius: 3px; }
    .mw-fast-news .fast-news-list p { 
        line-height: 22px; 
        margin-top: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
</style>